<template>
    <div>
        <DCard
            padding
        >
            <ProductPackageForm
                :errors="errors"
                :is-fulfillment-package="isFulfillmentPackage"
                :contract-max-nesting-level="contractMaxNestingLevel"
                @form-submitted="store"
            />
        </DCard>
    </div>
</template>

<script>
import ProductPackageForm from '~@/Components/Products/ProductPackages/Form'

export default {
    name: 'ProductPackageCreate',
    components: {
        ProductPackageForm
    },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        isFulfillmentPackage: {
            type: Boolean,
            default: () => { return false }
        },
        contractMaxNestingLevel: {
            type: Number,
            default: () => { return 3 }
        }
    },
    methods: {
        store (form) {
            form.post(this.$route('products.product-packages.store'))
        }
    }
}
</script>

<style scoped>

</style>
